"use client"

import { useEffect, useState } from "react"

/**
 * Width-based layout helper that stays hydration-safe.
 * SSR and the first client render both use width=0, then ResizeObserver
 * updates after mount. Reading `window` during useState init causes
 * server HTML (false/1-col) to disagree with client hydration (real width).
 */
export const useDevicePassedWidth = (checker: (width: number) => any) => {
  const [width, setWidth] = useState(0)

  useEffect(() => {
    const updateWidth = () => {
      setWidth(document.body.clientWidth)
    }

    updateWidth()

    // "resize" trên window chỉ bắn khi cửa sổ trình duyệt đổi kích thước, không bắt được
    // lúc document.body tự co giãn do nội dung load xong (SSR streaming, Suspense resolve,
    // web font/scrollbar...). Nếu đo trúng lúc layout chưa ổn định, các nơi dùng hook này
    // (vd. toggle mobile/desktop) sẽ khóa cứng sai kích thước cho tới lần resize thật tiếp theo.
    // ResizeObserver theo dõi trực tiếp body nên bắt được cả hai trường hợp.
    const resizeObserver = new ResizeObserver(updateWidth)
    resizeObserver.observe(document.body)

    return () => {
      resizeObserver.disconnect()
    }
  }, [])

  return checker(width)
}
